import React, { useState, useEffect } from 'react';
import './App.css';
import client1 from "./assets/307711214_465882182225423_8960107393949338946_n.jpg";
import client2 from "./assets/352090940_1293256038210336_1593492982373087541_n.png";
import client3 from "./assets/385093745_755990169873780_7938521011939695872_n.jpg";
import client4 from "./assets/504638335_122186654132049687_3453295559509395819_n.jpg";
import Raushan from "./assets/Raushan_saxena-removebg-preview.png"


const Icon = ({ name, size = 22 }) => {
  const s = { width: size, height: size, display: 'block', flexShrink: 0 };
  const p = { fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' };
  const icons = {
    target:    <svg style={s} viewBox="0 0 24 24" {...p}><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/></svg>,
    bolt:      <svg style={s} viewBox="0 0 24 24" {...p}><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>,
    brain:     <svg style={s} viewBox="0 0 24 24" {...p}><path d="M9.5 2A4.5 4.5 0 0114 6.5v0A4.5 4.5 0 0118.5 11v0A4.5 4.5 0 0114 15.5H9.5A4.5 4.5 0 015 11v0A4.5 4.5 0 019.5 6.5v0A4.5 4.5 0 019.5 2z"/><line x1="9.5" y1="11" x2="14.5" y2="11"/></svg>,
    globe:     <svg style={s} viewBox="0 0 24 24" {...p}><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 010 20M12 2a15.3 15.3 0 000 20"/></svg>,
    chat:      <svg style={s} viewBox="0 0 24 24" {...p}><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/></svg>,
    video:     <svg style={s} viewBox="0 0 24 24" {...p}><polygon points="23 7 16 12 23 17 23 7"/><rect x="1" y="5" width="15" height="14" rx="2"/></svg>,
    search:    <svg style={s} viewBox="0 0 24 24" {...p}><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>,
    users:     <svg style={s} viewBox="0 0 24 24" {...p}><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/></svg>,
    userX:     <svg style={s} viewBox="0 0 24 24" {...p}><path d="M16 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="8.5" cy="7" r="4"/><line x1="18" y1="8" x2="23" y2="13"/><line x1="23" y1="8" x2="18" y2="13"/></svg>,
    trendDown: <svg style={s} viewBox="0 0 24 24" {...p}><polyline points="23 18 13.5 8.5 8.5 13.5 1 6"/><polyline points="17 18 23 18 23 12"/></svg>,
    alert:     <svg style={s} viewBox="0 0 24 24" {...p}><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>,
    funnelX:   <svg style={s} viewBox="0 0 24 24" {...p}><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/></svg>,
    medal:     <svg style={s} viewBox="0 0 24 24" {...p}><circle cx="12" cy="8" r="6"/><path d="M15.477 12.89L17 22l-5-3-5 3 1.523-9.11"/></svg>,
    dollar:    <svg style={s} viewBox="0 0 24 24" {...p}><line x1="5" y1="6" x2="19" y2="6"/><line x1="5" y1="11" x2="19" y2="11"/><path d="M5 11l7 11"/><path d="M5 6h8a4 4 0 010 8H5"/></svg>,
    trendUp:   <svg style={s} viewBox="0 0 24 24" {...p}><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></svg>,
    check:     <svg style={s} viewBox="0 0 24 24" {...p}><polyline points="20 6 9 17 4 12"/></svg>,
    chevDown:  <svg style={s} viewBox="0 0 24 24" {...p}><polyline points="6 9 12 15 18 9"/></svg>,
    pin:       <svg style={s} viewBox="0 0 24 24" {...p}><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/></svg>,
    phone:     <svg style={s} viewBox="0 0 24 24" {...p}><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 014.69 15a19.79 19.79 0 01-3.07-8.67A2 2 0 013.6 4.22h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 12a16 16 0 006 6l.77-.77a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/></svg>,
    mail:      <svg style={s} viewBox="0 0 24 24" {...p}><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>,
    bulb:      <svg style={s} viewBox="0 0 24 24" {...p}><line x1="9" y1="18" x2="15" y2="18"/><line x1="10" y1="22" x2="14" y2="22"/><path d="M15.09 14c.18-.98.65-1.74 1.41-2.5A4.65 4.65 0 0018 8a6 6 0 00-12 0c0 1.4.5 2.6 1.5 3.5.76.76 1.23 1.52 1.41 2.5"/></svg>,
    rocket:    <svg style={s} viewBox="0 0 24 24" {...p}><path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 00-2.91-.09z"/><path d="M12 15l-3-3a22 22 0 012-3.95A12.88 12.88 0 0122 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 01-4 2z"/><path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0"/><path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"/></svg>,
    fb:        <svg style={s} viewBox="0 0 24 24" fill="currentColor" stroke="none"><path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"/></svg>,
    ig:        <svg style={s} viewBox="0 0 24 24" {...p}><rect x="2" y="2" width="20" height="20" rx="5"/><path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/></svg>,
    li:        <svg style={s} viewBox="0 0 24 24" fill="currentColor" stroke="none"><path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z"/><circle cx="4" cy="4" r="2"/></svg>,
    tw:        <svg style={s} viewBox="0 0 24 24" fill="currentColor" stroke="none"><path d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z"/></svg>,
    wa:        <svg style={s} viewBox="0 0 24 24" fill="currentColor" stroke="none"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347zM12 0C5.373 0 0 5.373 0 12c0 2.127.558 4.122 1.528 5.855L.057 23.03a1 1 0 001.217 1.217l5.175-1.471A11.944 11.944 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0z"/></svg>,
    close:     <svg style={s} viewBox="0 0 24 24" {...p}><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>,
    calendar:  <svg style={s} viewBox="0 0 24 24" {...p}><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>,
    star:      <svg style={s} viewBox="0 0 24 24" {...p}><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>,
  };
  return icons[name] || null;
};

// ── STRATEGY CALL MODAL ──────────────────────────────────────
function StrategyModal({ onClose }) {
  const [step, setStep] = useState(1);
  const [mform, setMform] = useState({ name: '', phone: '', company: '', budget: '', challenge: '', timeline: '' });
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);
const avatars = [
  "https://th.bing.com/th/id/OIP.tfqGVGE0JRx67a6VeNx-qwHaLJ?w=184&h=277&c=7&r=0&o=7&pid=1.7&rm=3",
  "https://th.bing.com/th/id/OIP.rfPEga6fhntmZI7HHy7k2AHaHa?w=184&h=184&c=7&r=0&o=7&pid=1.7&rm=3",
  "https://th.bing.com/th/id/OIP.zwURWAK9fhcX5GBx52360gHaHu?w=184&h=192&c=7&r=0&o=7&pid=1.7&rm=3",
  "https://th.bing.com/th/id/OIP.yqFzJ0nGiWOf6Pk8psdJJwHaHa?w=184&h=184&c=7&r=0&o=7&pid=1.7&rm=3"
];
<div style={styles.avatarRow}>
  {avatars.map((img, i) => (
    <img
      key={i}
      src={img}
      alt="avatar"
      style={{
        ...styles.avatar,
        marginLeft: i === 0 ? 0 : -10,
        objectFit: "cover"
      }}
    />
  ))}
</div>
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = ''; };
  }, []);

  const handleKey = e => { if (e.key === 'Escape') onClose(); };
  useEffect(() => {
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, []);

  const upd = e => setMform({ ...mform, [e.target.name]: e.target.value });

  const steps = [
    {
      title: 'Tell us about yourself',
      subtitle: 'Step 1 of 3 — Basic Info',
      fields: [
        { label: 'Your name', name: 'name', ph: 'Enter your name', type: 'text' },
        { label: 'Mobile Number', name: 'phone', ph: '10-digit number', type: 'tel' },
        { label: 'Company', name: 'company', ph: 'Your company name', type: 'text' },
      ]
    },
    {
      title: 'Marketing Goals',
      subtitle: 'Step 2 of 3 — Goals & Budget',
      fields: [
        { label: 'Monthly Marketing Budget', name: 'budget', ph: 'e.g. ₹50,000 – ₹2 Lakh', type: 'text' },
        { label: 'Timeline to Start', name: 'timeline', ph: 'e.g. Immediately, 1 month', type: 'text' },
      ]
    },
    {
      title: 'Biggest Challenge',
      subtitle: 'Step 3 of 3 — Tell us your problem',
      fields: [
        { label: 'Biggest challenge you faced?', name: 'challenge', ph: 'e.g. Junk leads will comes, High CPL, Low traffic on site...', type: 'textarea' },
      ]
    },
  ];

  const current = steps[step - 1];

  const canNext = () => {
    return current.fields.every(f => mform[f.name].trim() !== '');
  };

  const handleNext = () => {
    if (step < 3) setStep(step + 1);
    else handleSubmit();
  };

  const handleSubmit = async () => {
    setSubmitting(true);
    try {
      const res = await fetch('https://roasbadhao.com/api/realestate_leads.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: mform.name,
          phone: mform.phone,
          project: mform.company,
          location: 'Strategy Call',
          budget: mform.budget,
          challenge: mform.challenge,
          timeline: mform.timeline,
        }),
      });
      await res.json();
    } catch (_) {}
    setSubmitting(false);
    setDone(true);
  };

  return (
    <div style={styles.overlay} onClick={e => { if (e.target === e.currentTarget) onClose(); }}>
      <div style={styles.modal}>

        {/* LEFT PANEL */}
        <div style={styles.leftPanel}>
          <div style={styles.leftTop}>
            <div style={styles.brandDot}/>
            <span style={styles.brandName}>RoasBadhao</span>
          </div>
          <h2 style={styles.leftHeading}>Book a Free<br/>Strategy Call</h2>
          <p style={styles.leftSub}>30 minutes. No sales pressure.<br/>Sirf actionable insights.</p>

          <div style={styles.perks}>
            {[
              { icon: 'target', text: 'Custom lead generation strategy' },
              { icon: 'dollar', text: 'CPL benchmarking & audit' },
              { icon: 'brain',  text: 'AI verification demo' },
              { icon: 'trendUp',text: 'ROI projection for your project' },
            ].map(p => (
              <div key={p.text} style={styles.perkRow}>
                <span style={styles.perkIcon}><Icon name={p.icon} size={15}/></span>
                <span style={styles.perkText}>{p.text}</span>
              </div>
            ))}
          </div>

          <div style={styles.socialProof}>
           <div style={styles.avatarRow}>
  {avatars.map((img, i) => (
    <img
      key={i}
      src={img}
      alt="avatar"
      style={{
        ...styles.avatar,
        marginLeft: i === 0 ? 0 : -10,
        objectFit: "cover"
      }}
    />
  ))}
</div>
            <p style={styles.proofText}><strong>18+ clients</strong> already scaled with us</p>
            <div style={styles.starsRow}>
              {[1,2,3,4,5].map(i => <span key={i} style={{ color: '#fbbf24', fontSize: 12 }}>★</span>)}
              <span style={styles.ratingText}>4.9/5 rating</span>
            </div>
          </div>
        </div>

        {/* RIGHT PANEL */}
        <div style={styles.rightPanel}>
          <button style={styles.closeBtn} onClick={onClose}><Icon name="close" size={18}/></button>

          {done ? (
            <div style={styles.successWrap}>
              <div style={styles.successCircle}>
                <Icon name="check" size={32}/>
              </div>
              <h3 style={styles.successTitle}>Thanks! 🎉</h3>
              <p style={styles.successMsg}>
                Your Request has been recieved. Our team will contact in <strong>24 hrs.</strong> to you.
              </p>
              <button style={styles.doneBtn} onClick={onClose}>Close</button>
            </div>
          ) : (
            <>
              {/* Progress bar */}
              <div style={styles.progressWrap}>
                {[1,2,3].map(n => (
                  <React.Fragment key={n}>
                    <div style={{ ...styles.progressDot, background: n <= step ? '#16a34a' : '#e5e7eb' }}>
                      {n < step ? <Icon name="check" size={11}/> : <span style={{ fontSize: 10, color: n <= step ? '#fff' : '#9ca3af' }}>{n}</span>}
                    </div>
                    {n < 3 && <div style={{ ...styles.progressLine, background: n < step ? '#16a34a' : '#e5e7eb' }}/>}
                  </React.Fragment>
                ))}
              </div>

              <div style={styles.stepLabel}>{current.subtitle}</div>
              <h3 style={styles.stepTitle}>{current.title}</h3>

              <div style={styles.fieldsWrap}>
                {current.fields.map(f => (
                  <div key={f.name} style={styles.fieldGroup}>
                    <label style={styles.fieldLabel}>{f.label}</label>
                    {f.type === 'textarea' ? (
                      <textarea
                        name={f.name}
                        placeholder={f.ph}
                        value={mform[f.name]}
                        onChange={upd}
                        rows={4}
                        style={styles.textarea}
                      />
                    ) : (
                      <input
                        type={f.type}
                        name={f.name}
                        placeholder={f.ph}
                        value={mform[f.name]}
                        onChange={upd}
                        style={styles.input}
                      />
                    )}
                  </div>
                ))}
              </div>

              <div style={styles.btnRow}>
                {step > 1 && (
                  <button style={styles.backBtn} onClick={() => setStep(step - 1)}>← Back</button>
                )}
                <button
                  style={{ ...styles.nextBtn, opacity: canNext() ? 1 : 0.5, cursor: canNext() ? 'pointer' : 'not-allowed', marginLeft: step > 1 ? 12 : 0 }}
                  onClick={handleNext}
                  disabled={!canNext() || submitting}
                >
                  {submitting ? 'Submitting...' : step === 3 ? '🚀 Book My Strategy Call' : 'Next →'}
                </button>
              </div>

              <p style={styles.disclaimer}>
                <Icon name="calendar" size={12}/>&nbsp;
                Aapka data 100% safe hai. Spam nahi karenge.
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: 'fixed', inset: 0, zIndex: 9999,
    background: 'rgba(0,0,0,0.75)',
    backdropFilter: 'blur(6px)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    padding: '20px',
    animation: 'fadeIn 0.2s ease',
  },
  modal: {
    display: 'flex',
    width: '100%', maxWidth: 860,
    maxHeight: '90vh',
    borderRadius: 20,
    overflow: 'hidden',
    boxShadow: '0 32px 80px rgba(0,0,0,0.4)',
    fontFamily: "'Segoe UI', sans-serif",
  },
  leftPanel: {
    width: '42%',
    background: 'linear-gradient(160deg, #052e16 0%, #14532d 50%, #166534 100%)',
    padding: '40px 32px',
    display: 'flex', flexDirection: 'column',
    position: 'relative', overflow: 'hidden',
  },
  leftTop: { display: 'flex', alignItems: 'center', gap: 8, marginBottom: 32 },
  brandDot: { width: 10, height: 10, borderRadius: '50%', background: '#4ade80' },
  brandName: { color: '#fff', fontWeight: 700, fontSize: 15, letterSpacing: 0.5 },
  leftHeading: {
    color: '#fff', fontSize: 28, fontWeight: 800,
    lineHeight: 1.25, margin: '0 0 12px',
  },
  leftSub: { color: '#86efac', fontSize: 14, lineHeight: 1.6, margin: '0 0 32px' },
  perks: { display: 'flex', flexDirection: 'column', gap: 14, marginBottom: 'auto' },
  perkRow: { display: 'flex', alignItems: 'center', gap: 10 },
  perkIcon: {
    width: 30, height: 30, borderRadius: 8,
    background: 'rgba(255,255,255,0.1)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    color: '#4ade80', flexShrink: 0,
  },
  perkText: { color: '#d1fae5', fontSize: 13 },
  socialProof: { marginTop: 32, paddingTop: 24, borderTop: '1px solid rgba(255,255,255,0.1)' },
  avatarRow: { display: 'flex', marginBottom: 8 },
  avatar: {
    width: 32, height: 32, borderRadius: '50%',
    border: '2px solid #052e16',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    color: '#fff', fontSize: 12, fontWeight: 700,
  },
  proofText: { color: '#d1fae5', fontSize: 13, margin: '4px 0' },
  starsRow: { display: 'flex', alignItems: 'center', gap: 3 },
  ratingText: { color: '#86efac', fontSize: 12, marginLeft: 4 },

  rightPanel: {
    flex: 1, background: '#fff',
    padding: '36px 36px 32px',
    overflowY: 'auto',
    position: 'relative',
    display: 'flex', flexDirection: 'column',
  },
  closeBtn: {
    position: 'absolute', top: 16, right: 16,
    background: '#f3f4f6', border: 'none', borderRadius: 8,
    width: 36, height: 36, cursor: 'pointer',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    color: '#6b7280',
  },
  progressWrap: { display: 'flex', alignItems: 'center', marginBottom: 20 },
  progressDot: {
    width: 28, height: 28, borderRadius: '50%',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    color: '#fff', flexShrink: 0, transition: 'background 0.3s',
  },
  progressLine: { flex: 1, height: 3, borderRadius: 2, margin: '0 6px', transition: 'background 0.3s' },
  stepLabel: { color: '#16a34a', fontSize: 12, fontWeight: 600, letterSpacing: 1, textTransform: 'uppercase', marginBottom: 6 },
  stepTitle: { color: '#111827', fontSize: 22, fontWeight: 800, margin: '0 0 24px' },
  fieldsWrap: { display: 'flex', flexDirection: 'column', gap: 16, flex: 1 },
  fieldGroup: { display: 'flex', flexDirection: 'column', gap: 6 },
  fieldLabel: { color: '#374151', fontSize: 13, fontWeight: 600 },
  input: {
    padding: '12px 14px', borderRadius: 10,
    border: '1.5px solid #e5e7eb',
    fontSize: 14, color: '#111827',
    outline: 'none', transition: 'border 0.2s',
    fontFamily: 'inherit',
  },
  textarea: {
    padding: '12px 14px', borderRadius: 10,
    border: '1.5px solid #e5e7eb',
    fontSize: 14, color: '#111827',
    outline: 'none', resize: 'vertical',
    fontFamily: 'inherit', lineHeight: 1.5,
  },
  btnRow: { display: 'flex', marginTop: 24 },
  backBtn: {
    background: '#f3f4f6', border: 'none', borderRadius: 10,
    padding: '13px 20px', fontSize: 14, fontWeight: 600,
    color: '#374151', cursor: 'pointer',
  },
  nextBtn: {
    flex: 1, background: 'linear-gradient(135deg, #16a34a, #15803d)',
    border: 'none', borderRadius: 10,
    padding: '13px 20px', fontSize: 15, fontWeight: 700,
    color: '#fff', cursor: 'pointer',
    boxShadow: '0 4px 14px rgba(22,163,74,0.35)',
    transition: 'opacity 0.2s',
  },
  disclaimer: {
    display: 'flex', alignItems: 'center', gap: 4,
    color: '#9ca3af', fontSize: 12, marginTop: 12,
  },
  successWrap: {
    flex: 1, display: 'flex', flexDirection: 'column',
    alignItems: 'center', justifyContent: 'center', textAlign: 'center',
    padding: '20px',
  },
  successCircle: {
    width: 72, height: 72, borderRadius: '50%',
    background: 'linear-gradient(135deg, #16a34a, #15803d)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    color: '#fff', marginBottom: 20,
    boxShadow: '0 8px 24px rgba(22,163,74,0.3)',
  },
  successTitle: { color: '#111827', fontSize: 24, fontWeight: 800, margin: '0 0 12px' },
  successMsg: { color: '#6b7280', fontSize: 15, lineHeight: 1.6, margin: '0 0 28px' },
  doneBtn: {
    background: 'linear-gradient(135deg, #16a34a, #15803d)',
    border: 'none', borderRadius: 10,
    padding: '13px 36px', fontSize: 15, fontWeight: 700,
    color: '#fff', cursor: 'pointer',
  },
};

// ── MAIN APP ─────────────────────────────────────────────────
export default function App() {
  const [form, setForm] = useState({ name: '', project: '', location: '', budget: '', phone: '' });
  const [submitting, setSubmitting] = useState(false);
  const [submitMsg, setSubmitMsg] = useState(null);
  const [faqOpen, setFaqOpen] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const handleForm = e => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async () => {
    setSubmitMsg(null);
    const required = ['name', 'project', 'location', 'budget', 'phone'];
    const missing = required.filter(f => !form[f].trim());
    if (missing.length) { setSubmitMsg({ type: 'error', text: 'Please fill in all required fields.' }); return; }
    const phone = form.phone.replace(/\D/g, '');
    if (!/^[6-9]\d{9}$/.test(phone)) { setSubmitMsg({ type: 'error', text: 'Please enter a valid 10-digit Indian mobile number.' }); return; }
    setSubmitting(true);
    try {
      const res = await fetch('https://roasbadhao.com/api/realestate_leads.php', {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(form),
      });
      const data = await res.json();
      if (data.success) { setSubmitMsg({ type: 'success', text: data.message }); setForm({ name: '', project: '', location: '', budget: '', phone: '' }); }
      else setSubmitMsg({ type: 'error', text: data.message || 'Something went wrong.' });
    } catch { setSubmitMsg({ type: 'error', text: 'Network error. Please try again.' }); }
    finally { setSubmitting(false); }
  };

  const heroFeats = [
    { icon:'target', title:'Meta & Google Ads Expertise',  sub:'₹9+ Cr managed with proven ROI' },
    { icon:'bolt',   title:'WhatsApp Automation',           sub:'Instant engagement & lead nurturing' },
    { icon:'brain',  title:'AI Lead Verification',          sub:'Filter out junk, keep only serious buyers' },
    { icon:'globe',  title:'High-Converting Landing Pages', sub:'Custom designed for maximum conversions' },
  ];
  const stats = [
    { icon:'medal',   val:'6+',   lbl:'Years Experience' },
    { icon:'dollar',  val:'₹9+',  lbl:'Cr Ad Spend' },
    { icon:'trendUp', val:'₹55+', lbl:'Cr Revenue Generated' },
    { icon:'users',   val:'18+',  lbl:'Clients' },
  ];
  const painCards = [
    { icon:'userX',    title:'Junk Enquiries',         desc:'Getting irrelevant leads who are not serious buyers' },
    { icon:'trendDown',title:'Low Site Visits',        desc:'Leads not converting to actual site visits' },
    { icon:'alert',    title:'High CPL',                desc:'Spending too much per lead with poor quality' },
    { icon:'funnelX',  title:'Poor Conversion Funnel', desc:'No proper system to nurture and convert leads' },
  ];
  const growthCards = [
    { icon:'target', title:'Meta & Google Ads',    desc:'Performance-driven campaigns with proven ROI' },
    { icon:'chat',   title:'WhatsApp Automation',  desc:'Instant engagement and lead nurturing' },
    { icon:'globe',  title:'Landing Pages',         desc:'High-converting pages designed for real estate' },
    { icon:'brain',  title:'AI Call Verification', desc:'Filter junk leads automatically' },
    { icon:'video',  title:'Video Production',     desc:'Professional creatives that convert' },
    { icon:'search', title:'Lead Qualification',   desc:'Multi-step verification system' },
  ];
  const serviceCards = [
    { icon:'target', title:'Meta Ads',            desc:'Facebook & Instagram advertising with advanced targeting for real estate' },
    { icon:'search', title:'Google Ads',          desc:'Search, Display & YouTube campaigns for maximum reach' },
    { icon:'globe',  title:'Landing Pages',        desc:'Custom designed, high-converting pages optimized for conversions' },
    { icon:'chat',   title:'WhatsApp Automation', desc:'Automated lead engagement and nurturing via WhatsApp' },
    { icon:'brain',  title:'AI Verification',     desc:'Smart call verification to filter out junk leads automatically' },
    { icon:'video',  title:'Video Production',    desc:'Professional property videos and ad creatives that sell' },
  ];
  // const successCases = [
  //   { title:'Luxury Residential Project - Delhi NCR', leads:'450+', cpl:'₹280', visits:'180+', rev:'₹8.5 Cr' },
  //   { title:'Commercial Space Campaign',              leads:'320+', cpl:'₹350', visits:'125+', rev:'₹6.2 Cr' },
  //   { title:'Premium Villa Project - Gurgaon',       leads:'280+', cpl:'₹420', visits:'95+',  rev:'₹5.8 Cr' },
  // ];
  const successCases = [
  {
    title: "Larishreal Tech Pvt. Ltd.",
    leads: "1,250+",
    cpl: "₹180",
    visits: "320+",
    rev: "₹2.4 Cr"
  },
  {
    title: "Smart World",
    leads: "2,100+",
    cpl: "₹150",
    visits: "540+",
    rev: "₹4.8 Cr"
  },
  {
    title: "Nirala",
    leads: "1,600+",
    cpl: "₹170",
    visits: "410+",
    rev: "₹3.2 Cr"
  }
];
  const steps = [
    { num:'01', icon:'bulb',    title:'Strategy',     desc:'We analyze your project, target audience, and create a custom marketing strategy' },
    { num:'02', icon:'rocket',  title:'Execution',    desc:'Launch campaigns across Meta, Google with high-converting landing pages and creatives' },
    { num:'03', icon:'trendUp', title:'Optimization', desc:'Continuous A/B testing, audience refinement, and cost-per-lead optimization' },
    { num:'04', icon:'target',  title:'Scaling',      desc:'Scale winning campaigns and multiply your lead volume while maintaining quality' },
  ];
  // const testimonials = [
  //   { name:'Amit Sharma',  role:'CEO, Premium Builders' },
  //   { name:'Priya Verma',  role:'Director, Urban Estates' },
  //   { name:'Rajesh Kumar', role:'MD, Luxury Homes' },
  // ];

  const testimonials = [
  {
    name: "Amit Sharma",
    role: "Marketing Head, Larishreal Tech Pvt. Ltd.",
    feedback: "RoasBadhao helped us scale our project launches with consistent high-quality leads. Our CPL dropped significantly while conversions improved."
  },
  {
    name: "Rohit Bansal",
    role: "Sales Director, Smart World",
    feedback: "We saw a massive jump in site visits within weeks. Their targeting and funnel strategy is on point for real estate campaigns."
  },
  {
    name: "Neha Gupta",
    role: "Brand Manager, Nirala",
    feedback: "From lead generation to actual bookings, the entire pipeline improved. Highly reliable team with strong execution."
  }
];

  const faqs = [
    { q:'What is the minimum budget required to start?', a:'We recommend a minimum ad spend of ₹50,000/month to see meaningful results. Our management fee is separate and depends on the scope of services.' },
    { q:'How long does it take to see results?', a:'Most clients start seeing qualified leads within the first 7–10 days. Optimised CPL is typically achieved within 30–45 days.' },
    { q:'What makes your leads different from others?', a:'Our multi-step AI verification, WhatsApp automation, and dedicated follow-up system ensure only serious buyers make it through.' },
    { q:'Do you provide landing pages and creatives?', a:'Yes! We provide high-converting landing pages, professional video production, and creative designs tailored to your project.' },
  ];
  const auditBenefits = [
    'Complete marketing audit of your current campaigns',
    'Custom strategy roadmap for your project',
    'Competitor analysis and market insights',
    'Cost-per-lead benchmarking and optimization plan',
  ];
const clientLogos = [client1, client2, client3, client4];

  return (
    <div className="rb">
      {showModal && <StrategyModal onClose={() => setShowModal(false)} />}

      {/* BANNER */}
      <div className="rb-banner">
        <span>Get Free Real Estate Marketing Audit | Limited Slots</span>
        <button className="rb-banner-cta" onClick={() => setShowModal(true)}>Book Now</button>
      </div>

      {/* NAV */}
      <nav className="rb-nav">
        <div className="rb-wrap rb-nav-row">
          <span className="rb-logo">RoasBadhao</span>
          <div className="rb-nav-links">
            {['Home','Services','Portfolio','About','Contact'].map(l=>(
              <a key={l} href={`#${l.toLowerCase()}`}>{l}</a>
            ))}
          </div>
          <button className="rb-cta-green" onClick={() => setShowModal(true)}>Book Strategy Call</button>
        </div>
      </nav>

      {/* HERO */}
      <section className="rb-hero-bg" id="home">
        <div className="rb-wrap rb-hero-row">
          <div className="rb-hero-left">
            <h1>
              Generate High-Quality{' '}
              <span className="rb-green-text">Site Visit<br/>Leads</span>{' '}
              for Your Real<br/>Estate Projects
            </h1>
            <p className="rb-hero-para">
              Stop wasting money on junk enquiries. Get qualified leads with AI-powered
              verification, automated follow-ups, and proven marketing strategies.
            </p>
            <div className="rb-feat-list">
              {heroFeats.map(f=>(
                <div className="rb-feat-row" key={f.title}>
                  <span className="rb-feat-box"><Icon name={f.icon} size={18}/></span>
                  <div className="rb-feat-text">
                    <strong>{f.title}</strong>
                    <span>{f.sub}</span>
                  </div>
                </div>
              ))}
            </div>
            <div className="rb-hero-actions">
              <button className="rb-cta-green rb-cta-lg" onClick={() => setShowModal(true)}>Get Free Audit</button>
              <button className="rb-cta-outline rb-cta-lg">WhatsApp Us</button>
            </div>
          </div>

          {/* HERO FORM */}
          <div className="rb-hero-form-wrap">
            <div className="rb-form-card">
              <h2>Get Qualified Leads</h2>
              <p>Fill the form and our team will contact you</p>
              {[
                { label:'Name',         name:'name',     ph:'Your full name' },
                { label:'Project Name', name:'project',  ph:'Your project name' },
                { label:'Location',     name:'location', ph:'Project location' },
                { label:'Budget',       name:'budget',   ph:'Your marketing budget' },
                { label:'Phone',        name:'phone',    ph:'10-digit mobile number' },
              ].map(f=>(
                <div className="rb-field" key={f.name}>
                  <label>{f.label} <span className="rb-required">*</span></label>
                  <input type="text" name={f.name} placeholder={f.ph} value={form[f.name]} onChange={handleForm}/>
                </div>
              ))}
              {submitMsg && (
                <div style={{ padding:'10px 14px', borderRadius:8, marginBottom:12, fontSize:14, fontWeight:500,
                  backgroundColor: submitMsg.type==='success'?'#d1fae5':'#fee2e2',
                  color: submitMsg.type==='success'?'#065f46':'#991b1b',
                  border:`1px solid ${submitMsg.type==='success'?'#6ee7b7':'#fca5a5'}` }}>
                  {submitMsg.type==='success'?'✅ ':'❌ '}{submitMsg.text}
                </div>
              )}
              <button className="rb-form-submit" onClick={handleSubmit} disabled={submitting}
                style={{ opacity:submitting?0.7:1, cursor:submitting?'not-allowed':'pointer' }}>
                {submitting ? 'Submitting...' : 'Get Qualified Leads'}
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* STATS */}
      <section className="rb-stats-row">
        <div className="rb-wrap rb-stats-inner">
          {stats.map(s=>(
            <div className="rb-stat-item" key={s.lbl}>
              <span className="rb-stat-icon"><Icon name={s.icon} size={26}/></span>
              <strong className="rb-stat-val">{s.val}</strong>
              <span className="rb-stat-lbl">{s.lbl}</span>
            </div>
          ))}
        </div>
      </section>

      {/* TRUSTED BY */}
 <div className="rb-trusted">
  <p>TRUSTED BY LEADING REAL ESTATE BRANDS</p>

  <div className="rb-marquee">
    <div className="rb-marquee-track">
      {[...clientLogos, ...clientLogos].map((logo, i) => (
        <span className="rb-client-chip" key={i}>
          <img src={logo} alt={`client-${i}`} />
        </span>
      ))}
    </div>
  </div>
</div>

      {/* PAIN POINTS */}
      <section className="rb-dark-section" id="challenges">
        <div className="rb-wrap">
          <div className="rb-section-head rb-head-light">
            <h2>Struggling with Low-Quality Leads &amp; High CPL?</h2>
            <p>You're not alone. Most real estate businesses face these challenges</p>
          </div>
          <div className="rb-4col-grid">
            {painCards.map(c=>(
              <div className="rb-pain-card" key={c.title}>
                <span className="rb-pain-icon"><Icon name={c.icon} size={24}/></span>
                <h3>{c.title}</h3><p>{c.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* GROWTH SYSTEM */}
      <section className="rb-white-section">
        <div className="rb-wrap">
          <div className="rb-section-head">
            <h2>A Complete Real Estate <span className="rb-green-text">Growth System</span></h2>
            <p>Everything you need to generate, verify, and convert high-quality leads</p>
          </div>
          <div className="rb-3col-grid">
            {growthCards.map(c=>(
              <div className="rb-card-item rb-card-hover" key={c.title}>
                <span className="rb-card-icon-box"><Icon name={c.icon} size={22}/></span>
                <h3>{c.title}</h3><p>{c.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* SERVICES */}
      <section className="rb-gray-section" id="services">
        <div className="rb-wrap">
          <div className="rb-section-head">
            <h2>Our <span className="rb-green-text">Services</span></h2>
            <p>Comprehensive solutions for real estate lead generation</p>
          </div>
          <div className="rb-3col-grid">
            {serviceCards.map(c=>(
              <div className="rb-card-item rb-card-white rb-card-hover" key={c.title}>
                <span className="rb-card-icon-box"><Icon name={c.icon} size={22}/></span>
                <h3>{c.title}</h3><p>{c.desc}</p>
                <a href="#" className="rb-view-work">View Work →</a>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* SUCCESS STORIES */}
      {/* <section className="rb-white-section" id="portfolio">
        <div className="rb-wrap">
          <div className="rb-section-head">
            <h2>Success <span className="rb-green-text">Stories</span></h2>
            <p>Real results from real estate projects we've worked with</p>
          </div>
          <div className="rb-3col-grid">
            {successCases.map(c=>(
              <div className="rb-success-card" key={c.title}>
                <div className="rb-case-img"/>
                <div className="rb-case-body">
                  <h3>{c.title}</h3>
                  <div className="rb-case-metrics">
                    <div><span><Icon name="users" size={13}/> Leads Generated</span><strong>{c.leads}</strong></div>
                    <div><span><Icon name="dollar" size={13}/> Cost Per Lead</span><strong>{c.cpl}</strong></div>
                    <div><span><Icon name="pin" size={13}/> Site Visits</span><strong>{c.visits}</strong></div>
                    <div><span><Icon name="trendUp" size={13}/> Revenue</span><strong>{c.rev}</strong></div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section> */}
<section className="rb-white-section" id="portfolio">
  <div className="rb-wrap">
    <div className="rb-section-head">
      <h2>Success <span className="rb-green-text">Stories</span></h2>
      <p>Real results from real estate projects we've worked with</p>
    </div>

    <div className="rb-3col-grid">
      {successCases.map((c) => (
        <div className="rb-success-card" key={c.title}>
          
          {/* ❌ Image removed */}

          <div className="rb-case-body">
            
            {/* ✅ Client Name */}
            <h3>{c.title}</h3>

            <div className="rb-case-metrics">
              <div>
                <span><Icon name="users" size={13}/> Leads Generated</span>
                <strong>{c.leads}</strong>
              </div>

              <div>
                <span><Icon name="dollar" size={13}/> Cost Per Lead</span>
                <strong>{c.cpl}</strong>
              </div>

              <div>
                <span><Icon name="pin" size={13}/> Site Visits</span>
                <strong>{c.visits}</strong>
              </div>

              <div>
                <span><Icon name="trendUp" size={13}/> Revenue</span>
                <strong>{c.rev}</strong>
              </div>
            </div>

          </div>
        </div>
      ))}
    </div>
  </div>
</section>
      {/* ABOUT */}
      <section className="rb-gray-section" id="about">
        <div className="rb-wrap rb-about-row">
          <div className="rb-about-left">
            <h2>Meet <span className="rb-green-text">Raushan Saxena</span></h2>
            <p className="rb-about-role">Founder &amp; Performance Marketing Expert</p>
            <p className="rb-about-body">With over 6 years of experience in performance marketing, Raushan has helped real estate, D2C, and FMCG brands scale their businesses through data-driven strategies and proven systems.</p>
            <div className="rb-about-feats">
              {[
                { icon:'medal',   title:'6+ Years Experience',       sub:'Specialized in real estate lead generation and performance marketing' },
                { icon:'trendUp', title:'₹55+ Cr Revenue Generated', sub:'Managed campaigns across Real Estate, D2C, and FMCG sectors' },
                { icon:'target',  title:'Google Maps Ranking Expert',sub:'Ranked 50+ businesses on Google Maps for local visibility' },
              ].map(f=>(
                <div className="rb-feat-row" key={f.title}>
                  <span className="rb-feat-box"><Icon name={f.icon} size={18}/></span>
                  <div className="rb-feat-text"><strong>{f.title}</strong><span>{f.sub}</span></div>
                </div>
              ))}
            </div>
            <blockquote className="rb-quote">"My mission is to help real estate businesses stop wasting money on junk leads and build a predictable, scalable lead generation system."</blockquote>
            <p className="rb-quote-attr">— Raushan Saxena</p>
          </div>
          <div className="rb-about-photo"><img src={Raushan} alt="img" /></div>
        </div>
      </section>

      {/* TESTIMONIALS */}
      {/* <section className="rb-white-section">
        <div className="rb-wrap">
          <div className="rb-section-head">
            <h2>What Our <span className="rb-green-text">Clients Say</span></h2>
            <p>Hear from real estate leaders who transformed their lead generation</p>
          </div>
          <div className="rb-3col-grid">
            {testimonials.map(t=>(
              <div className="rb-testi-card" key={t.name}>
                <div className="rb-testi-video"><button className="rb-play">&#9654;</button></div>
                <div className="rb-testi-info"><strong>{t.name}</strong><span>{t.role}</span></div>
              </div>
            ))}
          </div>
        </div>
      </section> */}
<section className="rb-white-section">
  <div className="rb-wrap">
    <div className="rb-section-head">
      <h2>What Our <span className="rb-green-text">Clients Say</span></h2>
      <p>Hear from real estate leaders who transformed their lead generation</p>
    </div>

    <div className="rb-3col-grid">
      {testimonials.map((t) => (
        <div className="rb-testi-card" key={t.name}>
          
          {/* ⭐ Rating */}
          <div className="rb-testi-stars">★★★★★</div>

          {/* 💬 Testimonial Text */}
          <p className="rb-testi-text">“{t.feedback}”</p>

          {/* 👤 Client Info */}
          <div className="rb-testi-info">
            <strong>{t.name}</strong>
            <span>{t.role}</span>
          </div>

        </div>
      ))}
    </div>
  </div>
</section>
      {/* HOW IT WORKS */}
      <section className="rb-gray-section">
        <div className="rb-wrap">
          <div className="rb-section-head">
            <h2>How It <span className="rb-green-text">Works</span></h2>
            <p>Our proven 4-step process to transform your lead generation</p>
          </div>
          <div className="rb-4col-grid rb-steps-grid">
            {steps.map((s,i)=>(
              <div className={`rb-step-card${i===1?' rb-step-active':''}`} key={s.title}>
                <span className="rb-step-num">{s.num}</span>
                <span className={`rb-step-icon${i===1?' rb-step-icon-active':''}`}><Icon name={s.icon} size={22}/></span>
                <h3>{s.title}</h3><p>{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FREE AUDIT */}
      <section className="rb-green-section">
        <div className="rb-wrap rb-audit-inner">
          <h2>Get a Free Real Estate Marketing Audit</h2>
          <p className="rb-audit-sub">Limited slots available. Discover exactly how to reduce your CPL and increase quality leads.</p>
          <div className="rb-audit-card">
            <h3>What You'll Get:</h3>
            <div className="rb-audit-grid">
              {auditBenefits.map(b=>(
                <div className="rb-audit-item" key={b}>
                  <span className="rb-audit-chk"><Icon name="check" size={16}/></span>
                  <span>{b}</span>
                </div>
              ))}
            </div>
            <button className="rb-audit-btn" onClick={() => setShowModal(true)}>Book Your Free Audit Now</button>
            <p className="rb-audit-note">No commitment required. Get actionable insights in 30 minutes.</p>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="rb-white-section">
        <div className="rb-wrap">
          <div className="rb-section-head">
            <h2>Frequently Asked <span className="rb-green-text">Questions</span></h2>
            <p>Everything you need to know about working with us</p>
          </div>
          <div className="rb-faq-list">
            {faqs.map((f,i)=>(
              <div className="rb-faq-item" key={i}>
                <button className="rb-faq-q" onClick={()=>setFaqOpen(faqOpen===i?null:i)}>
                  <span>{f.q}</span>
                  <span className={`rb-faq-chevron${faqOpen===i?' rb-open':''}`}><Icon name="chevDown" size={18}/></span>
                </button>
                {faqOpen===i && <div className="rb-faq-ans">{f.a}</div>}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FINAL CTA */}
      <section className="rb-dark-cta">
        <div className="rb-wrap rb-dark-cta-inner">
          <h2>Stop Wasting Budget on Low-Quality Leads</h2>
          <p>Get a proven system that generates high-quality, verified leads at 30-40% lower CPL than industry average</p>
          <div className="rb-cta-btns">
            <button className="rb-cta-green rb-cta-lg" onClick={() => setShowModal(true)}>Get Qualified Leads →</button>
            <button className="rb-cta-outline-white rb-cta-lg">WhatsApp Now</button>
          </div>
          <span className="rb-cta-note">Join 18+ real estate businesses already generating qualified leads</span>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="rb-footer">
        <div className="rb-wrap rb-footer-grid">
          <div className="rb-footer-brand">
            <span className="rb-footer-logo">RoasBadhao</span>
            <p>Performance marketing agency specializing in real estate lead generation with proven results.</p>
            <div className="rb-socials">
              {[['fb','Facebook'],['ig','Instagram'],['li','LinkedIn'],['tw','Twitter']].map(([ic,al])=>(
                <a key={ic} href="#" aria-label={al} className="rb-social-btn"><Icon name={ic} size={16}/></a>
              ))}
            </div>
          </div>
          <div className="rb-footer-col">
            <h4>Services</h4>
            {['Meta Ads','Google Ads','Landing Pages','WhatsApp Automation','AI Verification','Video Production'].map(s=>(
              <a key={s} href="#">{s}</a>
            ))}
          </div>
          <div className="rb-footer-col">
            <h4>Quick Links</h4>
            {['Home','About Us','Portfolio','Free Audit','Contact'].map(s=>(
              <a key={s} href="#">{s}</a>
            ))}
          </div>
          <div className="rb-footer-col">
            <h4>Contact Us</h4>
            <div className="rb-footer-contacts">
              {[['mail','hello@roasbadhao.com'],['phone','+91 99116 89427'],['pin','Delhi NCR, India']].map(([ic,txt])=>(
                <span key={txt}><Icon name={ic} size={15}/>{txt}</span>
              ))}
            </div>
          </div>
        </div>
        <div className="rb-footer-bar">
          <div className="rb-wrap rb-footer-bar-inner">
            <span>© 2025 RoasBadhao. All rights reserved.</span>
            <a href="#">Privacy Policy</a>
          </div>
        </div>
      </footer>
    </div>
  );
}